export default __webpack_public_path__ + "c67ea51444aafa9bdcd5bdfd4f4a55bb.png";